import {
	type RouteResource,
	type RouterContext,
	createResource,
} from '@atlassian/react-resource-router';

const RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';

const TEN_SECONDS_IN_MILLIS = 1000 * 10;

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const productsJsmOrganizationListResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST,
	getKey: (routerContext: RouterContext) => routerContext.query.page,
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-products-jsm-organizations-list", jiraSpaEntry: "async-resource-products-jsm-organizations-list" */ './organizationsListFetch.tsx'
		),
	maxAge: TEN_SECONDS_IN_MILLIS,
});
